import React, { useMemo } from 'react';
import {
  StyleProvider,
  defaultBrandingData,
  TermsAndConditions,
} from '@relaynetwork/design-system';
import { FeedHeader } from '@app/client-config/product-group/components/feed-header/FeedHeader';

export type TermsAndConditionsPreviewProps = {
  showMenu: boolean;
  color: string;
};

export default function TermsAndConditionsPreview({
  showMenu = false,
  color,
}: TermsAndConditionsPreviewProps) {
  const brandingData = useMemo(
    () => ({
      ...defaultBrandingData,
      color: color,
    }),
    [color],
  );
  return (
    <StyleProvider brandingData={brandingData}>
      <FeedHeader
        showProductGroup={false}
        productGroupName={''}
        logoUrl={''}
        color={color}
        showBanner={false}
        showLogo={false}
        showTitleBar={false}
        isPreview={true}
        showMenu={showMenu} // Only this prop matters for Terms & Conditions preview, the rest set to false/empty
      />

      <TermsAndConditions
        isMobile={true}
      />
    </StyleProvider>
  );
}